var map = {
	"./euro2024.webp": 1400,
	"./euro2024_title.svg": 1401,
	"./event-sport-bg.jpg": 1402,
	"./event-sport-bg.png": 1403,
	"./home-icon-active.webp": 1404,
	"./home-icon.webp": 1405,
	"./img_bg-uefa.png": 1406,
	"./live-icon-active.webp": 1407,
	"./master-bg.webp": 1408,
	"./me-icon-active.webp": 1409,
	"./product-overview-bg.webp": 1410,
	"./promos-icon-active.webp": 1411,
	"./sponsor-icon-active.webp": 1412,
	"./uefa-icon-active.webp": 1413,
	"./uefa-icon.webp": 1414,
	"./uefa-prediction.webp": 1415,
	"./wwr-img.webp": 1416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 206;